<template lang="pug">
  #activity-overview
    WtTitle(card-title v-if="!isFeatured") Activity Overview

    template(v-if="challengeHasStarted && !isFeatured && memberSteps")
      //- .has-text-weight-semibold {{ memberActivityMessage }}
      WtStatRow(
        icon="gold-challenges"
        name="Percent Complete"
        :value="`${percentComplete.toLocaleString()}%`"
      )
      WtStatRow(
        icon="purple-two-shoe"
        :name="paceText"
        :value="memberPace.toLocaleString()"
      )
      WtStatRow(
        icon="yellow-mile-marker"
        :name="memberDistanceUnitText"
        :value="memberTotalStepsInChallengeByMemberUnits.toLocaleString()"
      )
    WtStatRow(
      v-if="!challenge.isPvsPChallenge"
      :icon="challenge && challenge.between === 'groups' ? 'primary-participants' : 'primary-participants'"
      :name="challenge && challenge.between === 'groups' ? 'Number of Teams' : 'Number of Participants'"
      :value="challenge && challenge.between === 'groups' ? _.get(challenge, 'teamCount', '_ _').toLocaleString() : _.get(challenge, 'memberCount', '_ _').toLocaleString()"
    )
    WtStatRow(
      v-if="challenge.isPvsPChallenge"
      :icon="'primary-participants'"
      :name="'Number of Programs'"
      :value="_.get(challenge, 'pVSpProgramsCount', '_ _').toLocaleString()"
    )
    WtStatRow(
      v-if="!(isWellnessChallenge || isPreventativeChallenge)"
      icon="orange-shoe"
      name="Daily Step Goal"
      :value="_.get(challenge, 'dailyStepGoal', '_ _').toLocaleString()"
    )
    WtStatRow(
      v-if="!(isWellnessChallenge || isPreventativeChallenge)"
      icon="blue-bar-chart"
      name="Total Step Goal"
      :value="_.get(challenge, 'totalStepsGoal', '_ _').toLocaleString()"
    )
    WtStatRow(
      v-if="isWellnessChallenge"
      icon="trophy-icon"
      name="Points Goals"
      :value="_.get(challenge, 'totalPointsGoal', '_ _').toLocaleString()"
    )
</template>

<script>
import { mapGetters } from "vuex";
import WtStatRow from "@@/WtStatRow/WtStatRow";
import WtTitle from "@@/WtTitle/WtTitle";

export default {
  name: "ChallengeActivityOverview",

  components: {
    WtStatRow,
    WtTitle
  },

  props: {
    challenge: {
      type: Object,
      default: () => {
        return {
          id: null,
          startDate: null,
          endDate: null
        };
      }
    },

    isFeatured: {
      type: Boolean,
      default: false
    },
    memberSteps: {
      type: Number,
      default: null
    }
  },
  computed: {
    ...mapGetters("members", ["member", "memberLoaded"]),

    memberDistanceUnit() {
      return this.memberLoaded
        ? this.member.memberData.units
        : this.$auth.user().memberData.units;
    },

    memberDistanceUnitValue() {
      return this.memberDistanceUnit === "Kilometers" ? 1250 : 2000;
    },

    memberDistanceUnitText() {
      return this.memberDistanceUnit === "Kilometers"
        ? "Total Kilometers"
        : "Total Miles";
    },

    memberTotalStepsInChallengeByMemberUnits() {
      return (
        this._.get(this.challenge, "totalStepsInChallenge", 0) /
        this.memberDistanceUnitValue
      );
    },

    daysSoFar() {
      const endDate = this.moment(this.challenge.endDate).isAfter()
        ? this.moment()
        : this.moment(this.challenge.endDate);
      return this.moment(endDate).diff(this.challenge.startDate, "days");
    },

    memberPace() {
      if (this.daysSoFar > 0) {
        const pace = this.memberSteps / this.daysSoFar;
        return Math.round(pace) || 0;
      }
      return this.memberSteps;
    },

    percentComplete() {
      const percentage = Math.floor(
        (this.memberSteps / this.challenge.totalStepsGoal) * 100
      );
      return percentage > 100 ? 100 : percentage;
    },

    challengeHasStarted() {
      return this.moment(this.challenge.startDate).isBefore();
    },

    challengeHasEnded() {
      return this.moment(this.challenge.endDate).isBefore();
    },

    memberActivityMessage() {
      if (this.percentComplete === 100) {
        return "You've completed the challenge! But that doesn't mean you should stop moving. Keep up the good work!";
      }
      if (this.challengeHasEnded) {
        return "Challenge has ended.";
      }
      return "You're doing great! Keep it up! ";
    },

    paceText() {
      if (this.challengeHasEnded) {
        return "Your Pace";
      }
      return "Current Pace";
    },

    isWellnessChallenge() {
      return this.challenge.isWellness;
    },

    isPreventativeChallenge() {
      return this.challenge.isPreventative;
    }
  }
};
</script>

<style lang="sass" scoped>
#activity-overview
  .member-info
    padding: 3.3rem
    border-radius: 100%
    +mobile
      padding: 4.3rem
</style>
